import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import Dropdown from 'react-bootstrap/cjs/Dropdown';
import styles from './buildTypeFilterSelector.module.sass';

export enum BuildTypeFilter {
  All = 'all',
  Adhoc = 'adhoc',
  Intraday = 'intraday',
  Nightly = 'nightly',
  Production = 'production'
}

interface PropsType {
  currentBuildTypeFilter: BuildTypeFilter;
  updateBuildTypeFilter: (newBuildsLimit: BuildTypeFilter) => void;
  disabled: boolean;
}

const getNameForFilter = (type: BuildTypeFilter) => {
  switch (type) {
    case BuildTypeFilter.Adhoc:
      return 'QAS';
    case BuildTypeFilter.Intraday:
      return 'Intraday';
    case BuildTypeFilter.Nightly:
      return 'Nightly';
    // case BuildTypeFilter.Playtest:
    //   return 'Playtest';
    case BuildTypeFilter.Production:
      return 'Production';
    // case BuildTypeFilter.Testing:
    //   return 'Testing';
    case BuildTypeFilter.All:
      return 'All Types';

    default:
      return 'All Types';
  }
};

const BuildTypeFilterSelector: FC<PropsType> = observer((props) => {

  const buttonText = () => {

    if (props.currentBuildTypeFilter == BuildTypeFilter.All)
      return getNameForFilter(BuildTypeFilter.All);

    else {
      return <><i className="fas fa-check me-1" /> {getNameForFilter(props.currentBuildTypeFilter)}</>;
    }
  };

  return (
    <Dropdown drop="down" className={styles.buildsFilter}>
      {!props.disabled
        &&
        <Dropdown.Toggle id="dropdown-basic"
                         className={props.currentBuildTypeFilter !== BuildTypeFilter.All && styles.active}>
          {buttonText()}
        </Dropdown.Toggle>
      }

      <Dropdown.Menu>
        {(Object.keys(BuildTypeFilter) as Array<keyof typeof BuildTypeFilter>).map(key => {
          return <Dropdown.Item key={key} onClick={() => props.updateBuildTypeFilter(BuildTypeFilter[key])}
                                className={BuildTypeFilter[key] == props.currentBuildTypeFilter && 'active'}>
            {getNameForFilter(BuildTypeFilter[key])}
          </Dropdown.Item>;
        })
        }
      </Dropdown.Menu>
    </Dropdown>
  );
});

export default BuildTypeFilterSelector;
